import React, { createContext, useContext } from 'react';
import { cn } from '@/lib/utils';

export type PipelineFormVariant = 'default' | 'pipeline';

const PipelineFormContext = createContext<{ variant: PipelineFormVariant }>({
  variant: 'default',
});

export function PipelineFormProvider({
  variant = 'default',
  children,
}: {
  variant?: PipelineFormVariant;
  children: React.ReactNode;
}) {
  return (
    <PipelineFormContext.Provider value={{ variant }}>
      {children}
    </PipelineFormContext.Provider>
  );
}

export function usePipelineForm() {
  const { variant } = useContext(PipelineFormContext);
  return {
    variant,
    isPipeline: variant === 'pipeline',
  };
}

/** Agrupa campos no estilo Kommo — borda contínua entre linhas */
export function PipelineFormSection({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const { isPipeline } = usePipelineForm();
  if (!isPipeline) return <>{children}</>;
  return (
    <div
      className={cn(
        '-mx-1 rounded-md border border-[#eceef2] dark:border-zinc-800 overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  );
}

export function pipelineFieldGridClass(isPipeline: boolean) {
  return isPipeline ? 'flex flex-col' : 'grid grid-cols-1 md:grid-cols-2 gap-6';
}

export function pipelineFieldGridClassCompact(isPipeline: boolean) {
  return isPipeline ? 'flex flex-col' : 'grid grid-cols-1 md:grid-cols-2 gap-4';
}
